import React from "react";
import "./Testimonials.css"; // Ensure you update this file
import { testimonials } from "../../portfolio";

const Testimonials = () => {
  return (
    <div className="testimonials-container">
      <h2 className="testimonials-title">{testimonials.title}</h2>
      <p className="testimonials-description">{testimonials.description}</p>
      <div className="testimonials-list">
        {testimonials.data.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            {/* Top Section (Name + Company) */}
            <div className="testimonial-header">
              <h3 className="testimonial-name">{testimonial.name}</h3>
              <p className="testimonial-position">{testimonial.position}</p>
            </div>
            {/* Divider */}
            <div className="testimonial-divider"></div>
            {/* Bottom Section (Testimonial Content) */}
            <p
            className="testimonial-feedback"
            dangerouslySetInnerHTML={{ __html: `"${testimonial.feedback}"` }}
            ></p>

          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
